import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import DatatableSection from "../../components/datatableSection/DatatableSection";
import ClientManagementDatatable from "./components/ClientManagementDatatable";

const ClientManagement = () => {
  return (
    <>
      <Sidebar />
      <MainSection>
        {/* Show breadcrumbs if desired */}
        <SectionHeader title="All Clients" />
        <DatatableSection>
          <ClientManagementDatatable />
        </DatatableSection>
      </MainSection>
    </>
  );
};

export default ClientManagement;
